import React, { useState } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { uploadCsvToProspect } from '../../services/uploadService';

const UploadCsv = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (selectedFile) {
      await uploadCsvToProspect(selectedFile);
      alert(`File "${selectedFile.name}" is ready for upload!`);
      setSelectedFile(null);
      // Here, you can implement file upload logic (e.g., send the file to a server)
    } else {
      alert('Please select a file first.');
    }
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={{ size: 6, offset: 3 }}>
          <h2 className="text-center">File Upload</h2>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="fileInput">Choose a file:</Label>
              <Input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
              />
            </FormGroup>
            <Button color="primary" type="submit" block>
              Upload
            </Button>
          </Form>
          {selectedFile && (
            <div className="mt-3">
              <h5>Selected File:</h5>
              <p>{selectedFile.name}</p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default UploadCsv;
